/*
 * Market Share Report - Main Report Page
 * 
 * This is a placeholder for the Market Share Report page.
 * TODO: Implement the full market share analysis functionality.
 * 
 * Features to implement:
 * - Market share analysis across different therapeutic classes
 * - Competitive positioning and trends
 * - State-by-state market penetration
 * - Export functionality
 */

import { ProtectedRoute } from '@shared/auth';
import React from 'react';

import { SectionDescription, SectionHeading } from '@/components-new/section';

const MarketShareReportPage = () => (
  <div className="mt-4 min-h-[calc(100vh-25px-54px)]">
    <div className="flex sm:flex-auto">
      <div className="basis-3/4">
        <SectionHeading level={2}>Market Share Report</SectionHeading>
        <SectionDescription>
          Comprehensive market share analysis and competitive positioning insights.
        </SectionDescription>
      </div>
    </div>

    <div className="mt-8">
      <div className="rounded-lg border border-gray-200 bg-white p-12 text-center">
        <svg
          className="mx-auto size-12 text-gray-400"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          aria-hidden="true"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
          />
        </svg>
        <h3 className="mt-2 text-sm font-semibold text-gray-900">
          Coming Soon
        </h3>
        <p className="mt-1 text-sm text-gray-500">
          The Market Share Report is currently under development. This report will provide comprehensive market share analysis and competitive positioning insights.
        </p>
      </div>
    </div>
  </div>
);

const MarketShareReportPageContainer = () => {
  return (
    <ProtectedRoute>
      <MarketShareReportPage/>
    </ProtectedRoute>
  );
};

export default MarketShareReportPageContainer;
